import coverImg from '../../../media/papers/allosteric2/cover.png';
import allosteric2PDF from '../../../media/papers/allosteric2/ssrn-6314747.pdf';

const allosteric2PaperData = {
    name: "AI Co-Folding Models for Allosteric Binding",
    displayTitle: "AI Co-Folding Models\nfor Allosteric Binding",
    category: "Computational Biology",
    tagline: "Unmasking the Biophysical Grammar of Allostery with Physics-Based Explainable AI",
    year: "2026",
    format: "SSRN",
    heroImage: coverImg,

    description: "AI co-folding models predict orthosteric ligand binding with high accuracy but show consistent failure on allosteric complexes across AlphaFold3, Protenix, Boltz-2, Chai-1, and DynamicBind. This study develops a dual explainable AI framework evaluated on stratified orthosteric and allosteric datasets. Energy landscape theory and local frustration analysis explain the dichotomy: orthosteric binding quenches pocket frustration, while allosteric sites remain neutral in both apo and holo states.",

    highlight: "Orthosteric binding creates dominant energetic funnels through ligand-induced frustration quenching, while allosteric sites preserve neutral frustration in both apo and holo states, explaining systematic failure on allosteric prediction.",

    techStack: [
        "AlphaFold3",
        "Protenix",
        "Boltz-2",
        "Chai-1",
        "DynamicBind",
        "Energy Landscape Theory",
        "Local Frustration Analysis",
        "Explainable AI",
        "Computational Biology"
    ],

    documents: [
        {
            type: 'pdf',
            src: allosteric2PDF,
            title: 'Read Full Paper (PDF)',
            alt: 'Full research paper'
        },
        {
            type: 'link',
            src: "https://ssrn.com/abstract=6314747",
            title: 'View on SSRN',
            alt: 'Full paper preprint'
        },
        {
            type: 'link',
            src: 'https://www.biorxiv.org/content/10.64898/2026.02.24.707829v1',
            title: 'View on bioRxiv (dual framework)',
            alt: 'Updated integrated preprint'
        }
    ],
    documentTitle: "Publication"
};

export default allosteric2PaperData;
